export default __webpack_public_path__ + "static/media/Luuri_Myyja.90de6ccb.svg";